module.exports = ":host {\n  height: 100%;\n  width: 100%; }\n\n.decimal-cell {\n  border: none;\n  border-radius: 6px;\n  min-width: 75px;\n  padding: 15px 10px 15px 10px;\n  text-align: right;\n  display: block;\n  color: #065462;\n  background-color: #f5f4f4;\n  font-weight: 500; }\n\n.decimal-cell:hover {\n  border: none;\n  border-radius: 6px; }\n\n.extractSpinner {\n  background: transparent;\n  position: fixed; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/extracts/components/extract-viewer.component.scss
// module id = ./src/app/extracts/components/extract-viewer.component.scss
// module chunks = main